var PoolType;
(function (PoolType) {
    PoolType["STANDARD"] = "STANDARD";
    PoolType["STABLE_PLAIN"] = "STABLE_PLAIN";
    PoolType["STABLE_META"] = "STABLE_META";
})(PoolType || (PoolType = {}));
export { PoolType };
//# sourceMappingURL=types.js.map